import { render, staticRenderFns } from "./BackupPropertyAttorneys.vue?vue&type=template&id=d127f15e"
import script from "./BackupPropertyAttorneys.vue?vue&type=script&lang=js"
export * from "./BackupPropertyAttorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports